import React from 'react';
import { Section, SectionHead } from './primitives';

// Numbered because the order is real — each step has an exit condition and
// gates the next. The segment and feature grids are unnumbered for that reason.
const STEPS = [
  {
    n: 'STEP 01',
    title: 'Intro call',
    body: 'You describe your users, your jurisdiction, and your risk posture. We tell you plainly whether Katbot fits.',
  },
  {
    n: 'STEP 02',
    title: 'Architecture review',
    body: 'We map the platform onto your cloud, your identity provider, and your compliance requirements, and agree on scope.',
  },
  {
    n: 'STEP 03',
    title: 'Pilot deployment',
    body: 'A working install in your sandbox, running paper trades against live market data, with your branding applied.',
  },
  {
    n: 'STEP 04',
    title: 'Go live',
    body: 'Your builder code, your risk limits, your users. Ongoing releases and a private support channel from day one.',
  },
];

export const ProcessSteps = () => (
  <Section id="process">
    <SectionHead
      eyebrow="How it works"
      title="From first call to your first live trade."
      lede="A real sequence, not a funnel. Each step has a clear exit condition, and you can stop at any of them."
    />
    <ol className="m-0 grid list-none gap-[18px] p-0 sm:grid-cols-2 lg:grid-cols-4">
      {STEPS.map((s) => (
        <li
          key={s.n}
          className="grid content-start gap-2 rounded-xl border border-gray-700/60 bg-gray-800/40 p-[22px]"
        >
          <span className="font-mono text-[0.72rem] tracking-[0.14em] text-cyan-400">{s.n}</span>
          <h3 className="m-0 text-base font-semibold text-white">{s.title}</h3>
          <p className="m-0 text-[0.92rem] text-gray-400">{s.body}</p>
        </li>
      ))}
    </ol>
  </Section>
);

export default ProcessSteps;
